/**
 * A tiny in-package signal so a screen's own "Ask the Orchestrator" prompt chips can drive the live
 * Column-3 Orchestrator chat (which lives in the shell, a sibling subtree). Decouples the chip from
 * the chat without threading props through every module: the chip dispatches a question, the chat
 * runs it, and the shell opens its Orchestrator panel/sheet so the answer is visible. Window-scoped
 * because ResponsiveShell mounts exactly one shell (mobile XOR desktop), so only one chat instance
 * ever receives the event - no double-send. No-ops during SSR / when there is no window.
 */
const ORC_ASK_EVENT = 'procuai:orc-ask';
/** Send a question to the live Orchestrator chat on the current screen. */
export function askOrchestrator(question) {
    if (typeof window === 'undefined')
        return;
    window.dispatchEvent(new CustomEvent(ORC_ASK_EVENT, { detail: question }));
}
/**
 * Registry-driven prompt chips (D-123 follow-on). The app shell injects the curated per-module
 * prompts from the contracts ORCHESTRATOR_MODULES registry once at load; each screen's chip row then
 * renders those texts, so chips never promise an answer the module's data cannot give. @procuai/ui
 * deliberately has no contracts dependency, which is why the map is injected rather than imported.
 * In the hosted no-login preview nothing is injected: getPrompts returns null and screens keep their
 * built-in demo chips (texts + tab choreography) as the fallback.
 */
let MODULE_PROMPTS = null;
/** Inject the curated per-module prompt texts (called once by the app shell; never in preview). */
export function setModulePrompts(map) {
    MODULE_PROMPTS = map;
}
/** The curated prompts for a module, or null when no registry was injected (hosted preview). */
export function getPrompts(slug) {
    const list = MODULE_PROMPTS?.[slug];
    return list && list.length > 0 ? list : null;
}
/** Subscribe to Orchestrator ask requests. Returns an unsubscribe function. */
export function onOrchestratorAsk(handler) {
    if (typeof window === 'undefined')
        return () => undefined;
    const listener = (e) => {
        const q = e.detail;
        if (typeof q === 'string')
            handler(q);
    };
    window.addEventListener(ORC_ASK_EVENT, listener);
    return () => window.removeEventListener(ORC_ASK_EVENT, listener);
}
//# sourceMappingURL=orchestratorBus.js.map